import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';

export interface Props {
  children?: FC;
  item?: PatiendId;
}

interface PatiendId {
  patientId?: string;
}
const OrderPatientIdCell: FC<Props> = ({
  item = {
    patientId: '',
  },
}) => {
  const { patientId } = item;
  return (
    <DataTableCell title={patientId || ''}>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{patientId || '--'}</p>
    </DataTableCell>
  );
};

/** Custom Account/Event Name cell */
export default OrderPatientIdCell;
